module.exports = __webpack_public_path__ + "static/media/hp-home-banner-mobile-@2x.6ba0edb7.jpg";